export class HitLoginDetails {
    vvvo: string;
    pin: string;

    constructor() {}
}
